import api from "@/lib/api";
import type { PaginatedResponse } from "@/types/common/api-types";
import type {
  Appointment,
  AppointmentCreate,
  AppointmentSearchParams,
  AppointmentUpdate,
} from "@/types/appointments/api-types/appointment-types";
import type {
  AvailabilityParams,
  AvailabilityResponse,
} from "@/types/appointments/api-types/availability-types";

export const appointmentsApi = {
  getAll: async (
    params: AppointmentSearchParams = {}
  ): Promise<PaginatedResponse<Appointment>> => {
    const response = await api.get<PaginatedResponse<Appointment>>(
      "/appointments",
      { params }
    );
    return response.data;
  },

  create: async (data: AppointmentCreate): Promise<Appointment> => {
    const response = await api.post<Appointment>("/appointments", data);
    return response.data;
  },

  update: async (
    id: number,
    data: AppointmentUpdate
  ): Promise<Appointment> => {
    const response = await api.put<Appointment>(`/appointments/${id}`, data);
    return response.data;
  },

  getAvailability: async (
    params: AvailabilityParams
  ): Promise<AvailabilityResponse> => {
    const response = await api.get<AvailabilityResponse>(
      "/appointments/availability",
      { params }
    );
    return response.data;
  },
};
